import ModeHelper from "./ModeHelper";

//方便表单处理表单权限（控制按钮是否可用）

export default class MessageDialogHelper{
    
    bill = null;

    constructor(bill){
        this.bill = bill;
    }

    
    async errMsg(title,text){
        await this.bill.$dialog.error({
            text: text,
            title: title
        });
    }

    async  infoMsg(title,text){
        await this.bill.$dialog.info({
            text: text,
            title: title
        });
    }

}